import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TermsAndConditionsDataAccessModule } from '@fantaz/terms-and-conditions/data-access';

@NgModule({
  imports: [CommonModule, TermsAndConditionsDataAccessModule],
})
export class TermsAndConditionsFeaturesShellModule {}
